import React from 'react';
import { default as FormBlank } from './forms/form-blank';
import { default as FormCreateAccount } from './forms/form-create-account';
import { default as FormForgotPassword } from './forms/form-forgot-password';
import { default as FormLogin } from './forms/form-login';
import { default as FormResetPassword } from './forms/form-reset-password';
import appConfig from '../../app-config';

import './login.scss';

const FormBlockNames = {
  CREATE_ACCOUNT: 'CREATE_ACCOUNT',
  LOGIN: 'LOGIN',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  RESET_PASSWORD: 'RESET_PASSWORD'
}

export default class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentBlockName: FormBlockNames.LOGIN
    };
  }

  render() {

    const { currentBlockName } = this.state;

    switch (currentBlockName) {
      case FormBlockNames.LOGIN:
        return <FormLogin
          onSwitchToValidateEmail={this.onSwitchToValidateEmail}
          onSwitchToCreateAccount={this.onSwitchToCreateAccount}
          onLoginClicked={this.onLoginClicked}
          onNotifyEvent={(e) => this.onNotifyEvent(e)}
        />;
      case FormBlockNames.CREATE_ACCOUNT:
        return <>
          {(appConfig.app.enableUserCreation === true &&
            <>
              <FormCreateAccount
                onSwitchToLogin={this.onSwitchToLogin}
                onNotifyEvent={(e) => this.onNotifyEvent(e)}
              />
            </>
          )}
        </>
      case FormBlockNames.FORGOT_PASSWORD:
        return <FormForgotPassword
          onSwitchToLogin={this.onSwitchToLogin}
          onSwitchToResetPassword={this.onSwitchToResetPassword}
          onNotifyEvent={(e) => this.onNotifyEvent(e)}
        />
      case FormBlockNames.RESET_PASSWORD:
        return <FormResetPassword
          onSwitchToLogin={this.onSwitchToLogin}
          onNotifyEvent={(e) => this.onNotifyEvent(e)}
        />
      default:
        return <FormBlank />;
    }
  }

  onLoginClicked = () => {
    if (this.props.onLoginClicked)
      this.props.onLoginClicked();
  }

  onNotifyEvent = (e) => {
    if (this.props.onNotifyEvent)
      this.props.onNotifyEvent(e);
  }

  onSwitchToLogin = () => {
    this.setState({
      currentBlockName: FormBlockNames.LOGIN
    });
  }

  onSwitchToCreateAccount = () => {
    this.setState({
      currentBlockName: FormBlockNames.CREATE_ACCOUNT
    });
  }

  onSwitchToValidateEmail = () => {
    this.setState({
      currentBlockName: FormBlockNames.FORGOT_PASSWORD
    });
  }

  onSwitchToResetPassword = () => {
    this.setState({
      currentBlockName: FormBlockNames.RESET_PASSWORD
    });
  }
}
